import { createContext } from 'react';

const informesContext = createContext();

export default informesContext;